import { forwardRef } from 'react';
import {
  FormControl as MuiFormControl,
  FormControlProps as MuiFormControlProps,
  FormLabel,
  Stack,
  FormHelperText,
} from '@mui/material';
import { TextFieldProps } from '../text-field';

export interface FormControlProps
  extends MuiFormControlProps,
    Pick<TextFieldProps, 'label' | 'labelInfo' | 'helperText'> {}

export const FormControl = forwardRef<HTMLDivElement, FormControlProps>(
  (
    { label, labelInfo, required, error, helperText, children, ...props },
    ref,
  ) => (
    <MuiFormControl ref={ref} {...props}>
      {label ? <FormLabel required={required}>{label}</FormLabel> : null}
      {labelInfo ? <FormLabel color='info'>{labelInfo}</FormLabel> : null}

      <Stack mt={0.5} spacing={1.5}>
        {children}
      </Stack>

      {error && helperText ? (
        <FormHelperText error>{helperText}</FormHelperText>
      ) : null}
    </MuiFormControl>
  ),
);
